import styled from 'styled-components';

export const DetailPanelLayout = styled.div`
	width: 100%;
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	padding: 1.5rem 1rem 1rem;
	background: ${({ theme }) => theme.v3.colors.white[0]};

	.deal-event-detail-header {
		margin-bottom: 1.5rem;
	}

	.deal-event-table {
		flex: 1;
		min-width: 0;
	}

	.deal-event-detail-session {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		flex-shrink: 0;
		width: 17.5rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		padding: 1rem 1rem 2.75rem;
		background: ${({ theme }) => theme.v3.colors.gray[0]};
	}
`;
